import request from '@/utils/request'

let Organization_typeApi = {

  /*组织类型列表*/
  list(data) {
    return request._post('/shop/plus.organization_type.Index/index', data);
},
/*添加组织类型*/
add(data) {
    return request._post('/shop/plus.organization_type.Index/add', data);
},
/*修改组织类型*/
edit(data) {
    return request._post('/shop/plus.organization_type.Index/edit', data);
},
/*删除组织类型*/
del(data) {
    return request._post('/shop/plus.organization_type.Index/del', data);
},
/*组织类型详情*/
detail(data) {
  return request._post('/shop/plus.organization_type.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.organization_type.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.organization_type.Setting/getSetting', data, errorback);
    },
}
export default Organization_typeApi;



// WEBPACK FOOTER //
// ./src/api/organization_type.js